import styled from "styled-components";
import { Color, Opacity } from "../../utils/style";
import MagicLink from "../MagicLink";
import Text from "../Text";

const EmptyCart = styled.div`
  width: 100%;
  text-align: center;
  padding: 30px 0px;
`;

const LinkContainer = styled.div`
  margin-top: 30px;
`;

const ShopLink = styled(MagicLink)`
  margin-top: 30px;
  border-bottom: 2px solid ${Color.ritualBlue};
  text-decoration: none;
  cursor: pointer;
  transition: opacity 200ms ease-in-out;

  &:hover {
    opacity: ${Opacity.light};
  }
`;

const FlyoutCartEmpty = () => (
  <EmptyCart>
    <Text id="cart.empty.message" defaultMessage="Your cart is empty." />
    <br />
    <Text
      id="cart.empty.message-second"
      defaultMessage="Fill it with something good."
    />
    <LinkContainer>
      <ShopLink to="/shop/daily-health">
        <Text id="home.featured-products.link" defaultMessage="Shop All" />
      </ShopLink>
    </LinkContainer>
  </EmptyCart>
);

export default FlyoutCartEmpty;
